// extracted by mini-css-extract-plugin
module.exports = {"work":"page_work__XYkkg","work_name":"page_work_name__EDrhz","work_itemList":"page_work_itemList__K7SfP"};